/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
"use strict"

import angular from "angular"

angular
  .module("uCountitUiApp")

  .directive("directionViewer", () => ({
    restrict: "E",
    templateUrl: "components/direction-viewer/direction-viewer.html",
    controller: "directionViewerCtrl",
    controllerAs: "vm",

    scope: {
      width: "=",
      height: "=",
      snapshotUrl: "=",
      list: "=",
      mode: "=",
    },
  }))
